import { SET_ASSIGNED_ARTWORK_ID } from '@app/actions/_types';
import { startLoading, endLoading, updateLoadingMessage } from '@app/actions/spinnerActions';
import { stateArtworkImage } from '@app/actions/artworkDataActions';

import endpoint from '@app/endpoint';

export const setAssignedArtworkId = artworkResponse => ({
  type: SET_ASSIGNED_ARTWORK_ID,
  payload: artworkResponse,
});

const prepareArtworkFormData = (artworkInfo, productId) => {
  const formData = new FormData();
  const { file, designName } = artworkInfo;
  formData.append('file', file);
  const artworkNameBlob = new Blob([designName], {
    type: 'text/plain;charset=UTF-8',
  });
  formData.append('name', artworkNameBlob);
  const fileNameBlob = new Blob([file.name], {
    type: 'text/plain;charset=UTF-8',
  });
  formData.append('filename', fileNameBlob);
  formData.append('productId', productId);
  return formData;
};

export const updateArtwork = (artworkInfo, productId, dispatch) => {
  const { artwork_id: artworkId } = artworkInfo;
  const artworkFormData = prepareArtworkFormData(artworkInfo, productId);
  dispatch(startLoading());
  endpoint.updateArtwork(artworkFormData, artworkId, response => {
    const { data: assignedArtworkId } = response || {};
    dispatch(setAssignedArtworkId(assignedArtworkId));
    dispatch(endLoading());
  });
};

export const uploadArtwork = (artworkInfo, productId, dispatch, behavior) => {
  const artworkFormData = prepareArtworkFormData(artworkInfo, productId);
  dispatch(startLoading());
  endpoint.uploadArtwork(artworkFormData, behavior, response => {
    const { data: assignedArtworkId } = response || {};
    dispatch(setAssignedArtworkId(assignedArtworkId));
    dispatch(endLoading());
  });
};

export const processArtworkUpload = (artworkInfo, productId, behavior) => dispatch => {
  const { artwork_id: artworkId } = artworkInfo;
  const method = artworkId ? updateArtwork : uploadArtwork;
  method.call(this, artworkInfo, productId, dispatch, behavior);
};

export const fetchArtwork = artworkId =>
  new Promise((resolve, reject) => {
    endpoint.fetchArtwork(artworkId, resolve, reject, this);
  });

export const fetchArtworkUploadResult = artworkId => dispatch =>
  new Promise(resolve => {
    endpoint.fetchArtworkStatus(
      artworkId,
      async ({ data: { artworkId, status: uploadStatus } }) => {
        let artworkData;

        if (uploadStatus === 'Done') {
          artworkData = await fetchArtwork(artworkId);
          dispatch(endLoading());
        } else {
          const validStatuses = ['ValidatingArtwork', 'StoringArtwork', 'GeneratingPreview', 'StoringPreview', 'RemovingContent'];
          const statusMessage = validStatuses.includes(uploadStatus)
            ? 'qau-status-' + uploadStatus
            : 'qau-status-processing';
          dispatch(updateLoadingMessage(statusMessage));
        }

        resolve(artworkData);
      },
      () => dispatch(endLoading()),
      this,
    );
  });

export const uploadArtworkToProject = () => (dispatch, getState) =>
  new Promise(resolve => {
    const {
      artwork: { info: artworkInfo, project: projectData },
      matrix: {
        ctx: { behavior },
      },
    } = getState();
    const { artwork_id: artworkId } = artworkInfo;
    const params = { artworkId, behavior, projectData };

    dispatch(startLoading());
    endpoint.uploadArtworkToProject(
      params,
      ({ data: imageDto }) => {
        dispatch(stateArtworkImage(imageDto));
        dispatch(endLoading());
        resolve({ artworkInfo, projectData, image: imageDto });
      },
      () => dispatch(endLoading()),
    );
  });
